import { create } from 'zustand';
import type { Folder } from '@/lib/inboxQuery';

/**
 * Выбор человека на экране «Входящие»: папка, канал, стадия.
 * Живёт в хранилище, а не в компоненте, чтобы переживать уход в переписку и обратно
 * и сбрасываться при смене проекта (кабинета).
 */
interface InboxUiState {
  accountId: number | null;
  folder: Folder;
  /** Выбранный канал или «Все». */
  channel: number | 'all';
  /** id стадии канала (InboxStage.id) — фильтр inbox_stage_id. */
  stageId: number | null;
  /** Чья воронка показана при «Все» (один из каналов с воронкой). */
  funnelInboxId: number | null;
  /** Сохранённая прокрутка списка по ключу выборки — на случай полного перемонтирования. */
  scroll: Record<string, number>;
  setFolder: (f: Folder) => void;
  setChannel: (c: number | 'all') => void;
  setStage: (id: number | null) => void;
  setFunnelInbox: (id: number | null) => void;
  setScroll: (key: string, y: number) => void;
  resetFor: (accountId: number | null) => void;
}

export const useInboxUi = create<InboxUiState>((set, get) => ({
  accountId: null,
  folder: 'mine',
  channel: 'all',
  stageId: null,
  funnelInboxId: null,
  scroll: {},
  setFolder: (folder) => set({ folder }),
  // Стадия принадлежит воронке канала — при смене канала она теряет смысл.
  setChannel: (channel) => set({ channel, stageId: null, funnelInboxId: null }),
  setStage: (stageId) => set({ stageId }),
  setFunnelInbox: (funnelInboxId) => set({ funnelInboxId, stageId: null }),
  setScroll: (key, y) => set((s) => ({ scroll: { ...s.scroll, [key]: y } })),
  resetFor: (accountId) => {
    if (get().accountId === accountId) return;
    set({ accountId, folder: 'mine', channel: 'all', stageId: null, funnelInboxId: null, scroll: {} });
  },
}));
